// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1W2sF","title":"FrontImage_title__vWemb"};